var rich = {
    white: {
        color: '#fff',
        align: 'center',
        fontWeight: 'bold',
        padding: [3, 0]
    }
};
var placeHolderStyle = {
    normal: {
        label: {
            show: false
        },
        labelLine: {
            show: false
        },
        color: 'rgba(0, 0, 0, 0)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0
    }
};

var seriesObj = [{
    name: '',
    type: 'pie',
    clockWise: false,
    radius: [60, 120],
    hoverAnimation: false,
    itemStyle: {
        normal: {
            label: {
                show: true,
                position: 'inner',
                fontWeight: 'bold',
                rich: rich
            },
            labelLine: {
                show: false,
            }
        }
    },
    data: []
}];
var option = {
    title: {
        text: "按数量统计",
        top: 8,
        left: 8,
        textStyle: {
            color: "#ffffff"
        }
    },
    tooltip: {
        show: false
    },
    legend: {
        show: false
    },
    toolbox: {
        show: false
    },
    series: seriesObj
}

option.calcData = function (scaleData, name, value) {
    var data = [];
    var colorArr = ['rgb(255, 153, 153)', 'rgb(255, 176, 63)', 'rgb(61, 186, 45)', 'rgb(43, 166, 254)', 'rgb(255,222,0)', 'rgb(255,0,0)'];
    var total = 0;
    for (var i = 0; i < scaleData.length; i++) {
        total += scaleData[i][value];
        data.push({
            value: scaleData[i][value],
            name: scaleData[i][name],
            label:{
                color: "#ffffff",
            },
            itemStyle: {
                normal: {
                    borderWidth: 4,
                    shadowBlur: 30,
                    borderColor: colorArr[i],
                    shadowColor: colorArr[i],
                    color: colorArr[i],
                    opacity: 0.75,
                }
            }
        });
    }

    option.series[0].data = data;

    var formatter = function (params) {
        var percent = 0;
        percent = ((params.value / total) * 100).toFixed(0);
        if (params.name !== '') {
            return params.name + '\n{white|' + '占比' + percent + '%}\n数量' + params.value;
        } else {
            return '';
        }
    };

    option.series[0].itemStyle.normal.label.formatter = formatter;
}

export default option;